(function () {
  const shopping = window.GiftShopping, hub = document.querySelector('.gifts-hub');
  const paginationTarget = location.hash === '#gift-grid-start' || location.hash === '#gift-ready-title';
  const productReturn = location.hash === '#gift-return';
  hub?.querySelectorAll('.collection-pagination a[href]').forEach(link => {
    const url = new URL(link.href, location.href);
    url.hash = 'gift-grid-start';
    link.href = url.href;
  });
  if (shopping && hub) {
    const key = `seifenlaedeli:gifts-hub:session:v1:${location.pathname}${location.search}`;
    const saved = shopping.read(key) || {}, selected = saved.selected || {};
    let userMoved = false;
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(type => {
      window.addEventListener(type, () => { userMoved = true; }, { passive: true, once: true });
    });
    const positionEntry = () => {
      if (userMoved) return;
      if (paginationTarget) {
        hub.querySelector('[data-gift-collection]')?.scrollIntoView({ block: 'start', behavior: 'instant' });
      } else if (productReturn && Number.isFinite(saved.scroll)) {
        window.scrollTo({ top: saved.scroll, behavior: 'instant' });
      }
    };
    // Normal visits never consume a saved offset. Only explicit navigation
    // anchors request positioning; native history restoration is left alone.
    requestAnimationFrame(positionEntry);
    window.addEventListener('load', positionEntry, { once: true });
    document.fonts?.ready.then(positionEntry);
    const persist = () => { try { shopping.write(key, { selected, scroll: window.scrollY }); } catch {} };
    window.addEventListener('pagehide', persist);
    const grid = hub.querySelector('[data-gift-collection]'), summary = shopping.node('aside');
    grid?.before(summary);
    let boxUrl = hub.dataset.giftBoxUrl || '/pages/geschenkbox';
    const localeRoot = window.Shopify?.routes?.root || '/';
    if (boxUrl.startsWith('/pages/') && localeRoot !== '/') boxUrl = `${localeRoot.replace(/\/$/, '')}${boxUrl}`;
    shopping.summary(summary, boxUrl);
    const tasks = [...hub.querySelectorAll('[data-gift-product]')].map(async card => {
      let data; try { data = JSON.parse(card.dataset.giftProduct); } catch { return; }
      const first = data.variants.find(v => String(v.id) === selected[data.id]) || data.variants.find(v => v.available) || data.variants[0];
      if (!first) return;
      let product = { productId: `gid://shopify/Product/${data.id}`, handle: data.handle, title: data.title, variantId: String(first.id), priceCents: first.price, available: first.available, themeMatch: false, currency: 'CHF' };
      const actions = card.querySelector('.product-card__actions'); if (!actions) return;
      actions.replaceChildren(); actions.classList.add('gift-shopping-actions');
      const selector = shopping.node('select', null, 'gift-shopping-variant'); selector.setAttribute('aria-label', `${shopping.w[12]}: ${data.title}`);
      const box = shopping.button(shopping.w[0], () => shopping.collect(product, card)); box.className = 'button'; box.disabled = true;
      const add = shopping.button(shopping.w[1], async event => {
        const selectedProduct = product;
        selector.disabled = true;
        try { await shopping.cartAction(selectedProduct, event.currentTarget, card, async () => (await shopping.productVariants(selectedProduct)).find(p => p.variantId === selectedProduct.variantId)); }
        finally { selector.disabled = false; add.disabled = !product.available; }
      }); add.className = 'button button--secondary'; add.disabled = true;
      const details = shopping.node('a', shopping.w[2]);
      const links = [...card.querySelectorAll('.product-card__media, .product-card__title-link'), details];
      links.forEach(link => link.addEventListener('click', () => { persist(); shopping.remember(); }));
      actions.append(add, details);
      let variants = [];
      const update = () => {
        const chosen = variants.find(v => v.variantId === selector.value); if (!chosen) return;
        product = chosen; selected[data.id] = chosen.variantId;
        links.forEach(a => { a.href = shopping.productUrl(chosen); });
        add.disabled = !chosen.available; box.disabled = true; box.remove();
        const price = card.querySelector('.product-card__price'); if (price) price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: 'CHF' }).format(chosen.priceCents / 100);
        const image = card.querySelector('.product-card__media img');
        if (image && chosen.imageUrl) { image.removeAttribute('srcset'); image.src = chosen.imageUrl; image.hidden = false; }
        const badge = card.querySelector('.product-card__badge'); if (badge) badge.hidden = chosen.available;
        shopping.loadCatalog().then(c => {
          if (product.variantId !== chosen.variantId) return;
          box.disabled = !chosen.available || !shopping.capacities({ [chosen.variantId]: 1 }, c).length;
          if (!box.disabled) actions.insertBefore(box, add);
          else box.remove();
        }).catch(() => { box.title = shopping.w[10]; });
      };
      selector.addEventListener('change', update);
      const load = async () => {
        selector.disabled = true;
        try {
          variants = await shopping.productVariants(product);
          if (variants.length > 1) actions.before(selector);
          else selector.remove();
          selector.replaceChildren(...variants.map(v => { const option = shopping.node('option', `${v.variantTitle} · CHF ${(v.priceCents / 100).toFixed(2)}${v.available ? '' : ' · —'}`); option.value = v.variantId; option.selected = v.variantId === product.variantId; return option; }));
          selector.disabled = false;
          const wanted = selected[data.id] || product.variantId;
          if (variants.some(v => v.variantId === wanted)) { selector.value = wanted; update(); }
          else {
            const prompt = ({de:'Bitte eine aktuelle Variante wählen.',en:'Please choose a current variant.',fr:'Veuillez choisir une variante actuelle.',ar:'يرجى اختيار نوع متاح.'})[document.documentElement.lang?.slice(0,2)] || 'Bitte eine aktuelle Variante wählen.';
            const missing = shopping.node('option', prompt); missing.value = wanted; missing.disabled = true; selector.prepend(missing); selector.value = wanted;
            actions.before(selector);
            add.disabled = true; box.disabled = true; box.remove();
            links.forEach(a => { const url = new URL(shopping.productUrl(product), location.origin); url.searchParams.delete('variant'); a.href = url.href; });
          }
          window.SeifeThemeVisuals?.enhanceSelect(selector, variants);
        } catch { actions.append(shopping.button(shopping.w[10], event => { event.currentTarget.remove(); load(); })); }
      };
      card.addEventListener('gift-shopping:product-changed', () => load());
      await load();
    });
    Promise.all(tasks).then(() => {
      requestAnimationFrame(positionEntry);
    });
  }
  function settle(media, failed) {
    media.setAttribute("aria-busy", "false");
    const status = media.querySelector("[data-product-media-status]");
    if (status) status.remove();
    if (!failed) return;
    const image = media.querySelector("img");
    const fallback = media.querySelector("[data-product-media-fallback]");
    if (image) image.hidden = true;
    if (fallback) fallback.hidden = false;
  }

  document.querySelectorAll(".gifts-hub [data-product-media]").forEach(function (media) {
    const image = media.querySelector("img");
    if (!image) {
      settle(media, true);
      return;
    }
    if (image.complete) {
      settle(media, image.naturalWidth === 0);
      return;
    }
    image.addEventListener("load", function () { settle(media, false); }, { once: true });
    image.addEventListener("error", function () { settle(media, true); }, { once: true });
  });
}());